import React from 'react';
import styled from 'styled-components';
import { fetchLogin } from '../requests/index';
import { hooks } from '@engelvoelkersamericas/common-story-ui';
import { getSelectValue } from './AsyncSelectModal';
const { useGlobalDispatch, useProfileState } = hooks;

export default function Icon(props) {

  const profile = useProfileState();

  const { label, icon, name, isReliance, accounts, link, affiliations } = props;
  const globalDispatch = useGlobalDispatch();
  async function handleLogin() {
    let relianceId;
    let affiliationId;
    const isBrandCentral = name === 'brand_central' ? true : false;

    if (isReliance) {
      try {
        if (accounts?.length > 1) {
          const uniqueIds = [];
          const filteredAccounts = [];
          accounts.forEach((a) => {
            if (!uniqueIds.includes(a.id)) {
              filteredAccounts.push(a);
              uniqueIds.push(a.id);
            }
          });
          const selected = await getSelectValue(
            'Select an account to use.',
            filteredAccounts.map((account) => ({
              value: account,
              id: account.id,
              label: account.label,
            }))
          );
          relianceId = selected.id;
        } else if (accounts?.length === 1) {
          relianceId = accounts[0].id;
        } else {
          // use reliance account id on staff table
        }
      } catch (error) {
        // closed the modal without selection
        return;
      }
    }

    if (isBrandCentral) {
      try {
        if (affiliations?.length > 1) {
          const uniqueIds = [];
          const filteredAffiliations = [];
          affiliations.forEach((a) => {
            if (!uniqueIds.includes(a.userToShopId)) {
              filteredAffiliations.push(a);
              uniqueIds.push(a.userToShopId);
            }
          });
          const selected = await getSelectValue(
            'Select an account to use.',
            filteredAffiliations.map((affiliation) => ({
              value: affiliation,
              id: affiliation.userToShopId,
              label: affiliation.shop,
            }))
          );
          affiliationId = selected.userToShopId;
        } else if (affiliations?.length === 1) {
          affiliationId = affiliations[0].userToShopId;
        } 
      } catch (error) {
        // closed the modal without selection
        return;
      }
    }

    try {
      globalDispatch({ type: 'set global loading', payload: true });
      await fetchLogin(name, relianceId, link, profile.email, affiliationId, profile.staffId);
      globalDispatch({ type: 'set global loading', payload: false });
    } catch (error) {
      // need to do something with error
    }

    globalDispatch({ type: 'set global loading', payload: false });
  }
  // href={`${API}/apps/${name}/login`} target="_blank"
  return (
    <li style={{ position: 'relative' }} onClick={handleLogin}>
      <Container>
        <div className='hover-bg'></div>
        <img src={icon} alt={label} />

        <p>{label}</p>
      </Container>
    </li>
  );
}

const Container = styled.a`
  width: 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.01px;
  font-size: 1.6rem;
  &:hover {
    cursor: pointer;
    .hover-bg {
      background-color: rgba(218, 220, 224, 0.25);
    }
  }
  .hover-bg {
    position: absolute;
    width: 120px;
    height: 120px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -60%);
    border-radius: 4px;
    transition: 0.3s;
  }

  img {
    width: 100%;
    height: 56px;
    z-index: 3;
  }

  p {
    text-align: center;
    margin-top: 10px;
    width: 90px;
    font-weight: 400;
  }
`;
